<template>
    <div class="row" v-if="refundList != null">
      <div class="col-lg-12">
        <div class="form-box">
          <div class="form-title-wrap">
            <div class="d-flex align-items-center justify-content-between">
              <h3 class="title">İade</h3>
            </div>
          </div>
          <div class="form-content pb-2">

            <h3 class="title">İade Listesi</h3>
            <p class="font-size-14">{{ refundList.length }} listeleniyor</p>

            <div class="table-form table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Reservation</th>
                  <th scope="col">Tutar</th>
                  <th scope="col">Tip</th>
                  <th scope="col">Tarih</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="payment in refundList">
                  <th scope="row">#{{ payment.id}}</th>
                  <th><a :href="basePath+'/bookings/'+payment.bookingId">#{{payment.bookingId}}</a></th>
                  <th>{{ payment.amount |toCurrency}}</th>
                  <th>{{ payment.type }}</th>
                  <th>{{ payment.createDate | ddMMyyyyHHmmSS }}</th>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "RefundList",
  computed:{
    refundList:{
      get(){
        return this.$store.getters.getRefundList
      }
    }
  }
}
</script>

<style scoped>

</style>